import { useEffect, useState } from "react";
import type { NavigateFunction } from "react-router-dom";
import type { SetActiveNavigate } from "@clerk/shared/types";
import google from "@/assets/google.svg";
import microsoft from "@/assets/microsoft.svg";

/** Where a finished sign-in / sign-up lands; ProtectedRoute sends new users on to onboarding. */
export const APP_HOME = "/dashboard/campaigns";
export const SSO_CALLBACK_PATH = "/sso-callback";
export const TERMS_URL = "https://www.uplodio.com/terms-of-use";
export const PRIVACY_URL = "https://www.uplodio.com/privacy-policy";
// How long an OAuth button may spin without the page navigating away.
export const OAUTH_STALL_MS = 5000;

// The providers both Clerk instances allow to sign in (Dub and TikTok are
// connect-only, from Settings → Personal).
export const OAUTH_PROVIDERS = [
  { strategy: "oauth_google", label: "Google", icon: google },
  { strategy: "oauth_microsoft", label: "Microsoft", icon: microsoft },
] as const;
export type AuthOAuthStrategy = (typeof OAUTH_PROVIDERS)[number]["strategy"];

/**
 * finalize()'s navigate callback. decorateUrl can hand back an absolute URL
 * (Clerk's Safari ITP workaround), which needs a full page load.
 */
export function navigateToApp(navigate: NavigateFunction): SetActiveNavigate {
  return ({ decorateUrl }) => {
    const url = decorateUrl(APP_HOME);
    if (url.startsWith("http")) window.location.href = url;
    else navigate(url);
  };
}

/** Seconds left before "Resend code" may be pressed again. */
export function useResendCooldown(seconds = 30) {
  const [left, setLeft] = useState(0);
  useEffect(() => {
    if (left <= 0) return;
    const timer = setTimeout(() => setLeft((s) => s - 1), 1000);
    return () => clearTimeout(timer);
  }, [left]);
  return { left, start: () => setLeft(seconds) };
}
